<template>
  <base-sign-page
    :title-text="titleText"
    :note-text="noteText"
    :column-list="columnList"
    :data-list="dataList"
    :search-parms="searchParms"
    :form-parms="formParms"
    :his-data="chooseData"
    :openDialog="openDialog"
    :fileDataIds="fileDataIds"
    @formHandleClose="openDialog = false"
    :dataFileDirPath="dataFileDirPath"
    :data-file-title="dataFileTitle"
    :toolbox="showToolBox"
    :export-file-name="exportFileName"
    :open-dialog-data-file="openDialogDataFile"
    @dataFileHandleClose="openDialogDataFile = false"
    @formSubmit="formSubmit"
    :dataFilefuns="dataFilefuns"
    @clickSearch="loadData"
    @countDataChange="countDataChange"
    :count-fun="countFun"
    :show-search="true"
    :loading="loading"
    :dataFileUploadCheck="dataFileUploadCheck"
    @tableAction="tableAction"
    :on-form-change="onFormChange"
    :table-actions="tableActionsAuth"
    :table-actions-width="tableActionsWidth"
    :table-actions-fixed="tableActionsFixed"
    :title-menus="titleMenusAuth"
    @clickTitleMenu="clickTitleMenu"
    :simple-filter="simpleFilter"
    :table-size="tableSize"
    @dataFileUpdate="dataFileUpdate"
    :apply-data-log-columns="applyDataLogColumns"
    :applicable-type="applicableType"
    @checkDataChange="checkDataChange"
    ref="page"
    :need-pagination="true">
    <template v-slot:title>
      <slot name="title">
      </slot>
      <slot>
      </slot>
    </template>
  </base-sign-page>
</template>

<script>
import BaseSignPage from '@/components/base/BaseSignPage'

import {
  dateOperating
} from '@/fmlib'

import { dataAppleRequest } from '@/api'

function diff (source, update) {
  let newData = {}
  let hisData = {}

  if (!source) {
    return {hisData: {}, newData: update}
  }

  let sourceKey = Object.keys(source)
  let keys = [...sourceKey, ...Object.keys(update).filter(k => !sourceKey.includes(k))]
  for (const key of keys) {
    if (source[key] !== update[key]) {
      newData[key] = update[key]
      hisData[key] = source[key]
    }
  }
  return {newData, hisData}
}

function stringify (key, value) {
  if (Array.isArray(value)) {
    return value.join(',')
  } else if (value instanceof Date) {
    return dateOperating.computeDay({days: 0, date: value, format: 'yy-mm-dd hh:mm:ss'})
  } else {
    return value
  }
}

export default {
  name: 'SignPage',
  components: {
    BaseSignPage
  },
  props: {
    applicableType: { type: String, default: null },
    dealApplyData: { type: Function, default: (v) => v },
    initAddFormData: {
      type: Function
    },
    onFormChange: {
      type: Function
    },
    allAuthFuns: {
      type: Boolean
    },
    titleText: {
      type: String
    },
    dataFileUploadCheck: {
      type: Function
    },
    initSearchData: {
      type: Object
    },
    dataFileParm: {
      type: Object
    },
    dealSearchParm: {
      type: Function
    },
    // funAuth: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // },
    request: {
      type: Object
    },
    formParmsAdd: {
      type: Array
    },
    formParmsUpdate: {
      type: Array
    },
    titleMenus: {
      type: Array,
      default: () => {
        return [
          { key: 'add', label: '新增' }
        ]
      }
    },
    tableActions: {
      type: Array,
      default: () => {
        return [
          { key: 'edit', label: '修改' },
          { key: 'del', label: '删除' }
        ]
      }
    },
    searchParms: {
      type: Array
    },
    dealData: {
      type: Function
    },
    getFileDataIds: {
      type: Function
    },
    dealFormData: {
      type: Function
    },
    columnList: {
      type: Array
    },
    tableActionsWidth: { type: Number, default: null },
    tableActionsFixed: { type: Boolean, default: false },
    simpleFilter: { type: Boolean, default: true },
    tableSize: { type: String, default: 'norm' },
    exportFileName: { default: '导出数据' },
    applyDataLogColumns: { type: Array },
  },
  created () {
    this.loadData(this.initSearchData)
  },
  methods: {
    dataFileUpdate (parm) {
      this.fileDataIds = parm
      this.$emit('dataFileUpdate', parm, this)
    },
    getTableData () {
      return this.$refs.page.getTableData()
    },
    countFun (data) {
      return data.length
    },
    countDataChange (data) {
      this.noteText = '总数:' + data
    },
    tableAction (data) {
      this.chooseData = data.data
      this.sourceData = data.action.indexOf('apply') > -1 ? JSON.parse(JSON.stringify(data.data)) : null
      this.tableActionKey = data.action
      this.clickTitleMenuKey = null
      let action = this.tableActions.find(v => v.key === data.action)
      if (action && action.dealFun) {
        action.dealFun(this, this.chooseData)
      } else if (data.action === 'edit' || data.action === 'applyEdit') {
        this.formParms = this.formParmsUpdate
        this.openDialog = true
      } else if (data.action === 'data_file') {
        this.fileDataIds = this.getFileDataIds ? this.getFileDataIds(this.chooseData) : (this.chooseData.fileIds ? this.chooseData.fileIds.split(',') : [])
        this.openDialogDataFile = true
      } else if (data.action === 'del' || data.action === 'applyDel') {
        this.delData()
      } else {
        this.$emit('tableAction', data, this)
      }
    },
    async delData () {
      const result = await this.$dialog.confirm({title: '系统提示', content: '确定删除' + this.titleText.replace('管理', '') + '吗?'})
      if (result) {
        if (this.tableActionKey.indexOf('apply') > -1) {
          await dataAppleRequest.add({
            dataType: this.applicableType,
            dataId: this.chooseData.id,
            type: 'del',
            applyUserId: this.$store.getters.userInfo.id,
            hisData: JSON.stringify(this.chooseData, stringify),
            status: 'wait'
          })
          this.$notify({
            title: '系统提示',
            message: this.titleText.replace('管理', '') + '已申请删除',
            type: 'info'
          })
          this.$emit('dataUpdate', this.chooseData)
        } else {
          this.request.del(this.chooseData.id).then(() => {
            this.$notify({
              title: '系统提示',
              message: this.titleText.replace('管理', '') + '已删除',
              type: 'info'
            })
            this.$emit('dataUpdate', this.chooseData)
            this.loadData()
          })
        }
      }
    },
    formSubmit (data, resolve) {
      if (this.dealFormData) {
        try {
          data = this.dealFormData(data, this)
        } catch (e) {
          resolve()
          return
        }
      }
      for (let key in data) {
        if (data[key] instanceof Date) {
          data[key] = dateOperating.computeDay({days: 0, date: data[key], format: 'yy-mm-dd hh:mm:ss'})
        }
        if (data[key] instanceof Array) {
          data[key] = data[key].join(',')
        }
      }

      if (this.applicableType && (this.tableActionKey || this.clickTitleMenuKey || '').indexOf('apply') > -1) {
        return this.applyFormSubmit(this.chooseData ? this.chooseData.id : null, data, resolve)
      }

      if (this.chooseData && this.chooseData.id) {
        this.request.update(this.chooseData.id, data).then(() => {
          this.openDialog = false
          this.$notify({
            title: '系统提示',
            message: this.titleText.replace('管理', '') + '修改完成',
            type: 'success'
          })
          resolve()
          this.loadData()
          this.$emit('dataUpdate', data)
        }).catch((e) => {
          console.log(e)
          resolve()
        })
      } else {
        this.request.add(data).then(() => {
          this.openDialog = false
          this.$notify({
            title: '系统提示',
            message: this.titleText.replace('管理', '') + '新增完成',
            type: 'success'
          })
          resolve()
          this.loadData()
          this.$emit('dataUpdate', data)
        }).catch((e) => {
          console.log(e)
          resolve()
        })
      }
    },
    async applyFormSubmit (id, data, resolve) {
      let res = this.dealApplyData(diff(this.sourceData, data), data)

      if (res === false) {
        this.openDialog = false
        this.$notify({
          title: '系统提示',
          message: '数据无变化',
          type: 'info'
        })
        return resolve()
      }

      let param = {
        dataType: this.applicableType,
        dataId: id,
        type: id ? 'edit' : 'add',
        applyUserId: this.$store.getters.userInfo.id,
        hisData: JSON.stringify(res.hisData, stringify),
        newData: JSON.stringify(res.newData, stringify),
        status: 'wait'
      }
      try {
        await dataAppleRequest.add(param)
        this.openDialog = false
        this.$notify({
          title: '系统提示',
          message: this.titleText.replace('管理', '') + '申请' + (id ? '修改' : '新增') + '成功',
          type: 'success'
        })
        resolve()
        this.loadData()
        this.$emit('dataUpdate', data)
      } catch (error) {
        resolve()
      }
    },
    clickTitleMenu (key, parm) {
      this.chooseData = null
      this.sourceData = null
      this.clickTitleMenuKey = key
      this.tableActionKey = null
      if (parm.dealFun) {
        parm.dealFun(this)
      } else if (key === 'add' || key === 'applyAdd') {
        if (this.initAddFormData) {
          this.chooseData = this.initAddFormData()
        }
        this.formParms = this.formParmsAdd
        this.openDialog = true
      } else {
        this.$emit('clickTitleMenu', key, this)
      }
    },
    async loadData (searchParm) {
      if (!this.$authFunsProxy.get) {
        this.loading = false
        return
      }
      try {
        let searchParmData = this.dealSearchParm ? this.dealSearchParm(searchParm) : searchParm
        this.searchData = searchParmData || this.searchData
        this.loading = true
        let data = await this.request.get(this.searchData)
        if (this.dealData) {
          this.dataList = await this.dealData(data)
        } else {
          this.dataList = data
        }
        this.countDataChange(this.dataList.length)
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    checkDataChange (parm) {
      this.$emit('checkDataChange', parm)
    }
  },
  computed: {
    showToolBox () {
      return ['export'].concat(['table-config'].filter(v => this.$authFunsProxy[v]).map(v => v.replace('table-', '')))
    },
    tableActionsAuth () {
      return !this.applicableType ? this.tableActions.filter(v => this.$authFunsProxy[v.key] || this.allAuthFuns) : [
        ...this.tableActions,
        { key: 'applyEdit', label: '申请修改' },
        { key: 'applyDel', label: '申请删除' }
      ].filter(v => this.$authFunsProxy[v.key] || this.allAuthFuns)
    },
    titleMenusAuth () {
      return !this.applicableType ? this.titleMenus.filter(v => this.$authFunsProxy[v.key] || this.allAuthFuns) : [...this.titleMenus, { key: 'applyAdd', label: '申请新增' }, { key: 'applyLog', label: '信息变更申请记录' }].filter(v => this.$authFunsProxy[v.key] || this.allAuthFuns)
    },
    dataFilefuns () {
      return {
        get: this.$authFunsProxy.getDataFile,
        upload: this.$authFunsProxy.updateDataFile,
        down: this.$authFunsProxy.downDataFile,
        del: this.$authFunsProxy.delDataFile,
        mkdir: this.$authFunsProxy.mkdirDataFile
      }
    },
    dataFileTitle () {
      return (this.tableActions.find(v => v.key === 'data_file') || {label: ''}).label
    },
    dataFileDirPath () {
      if (this.chooseData && this.dataFileParm && this.dataFileParm.pDirPath) {
        return this.dataFileParm.pDirPath + this.chooseData.id + '/'
      }
      return null
    }
  },
  data () {
    return {
      formParms: [],
      chooseList: [],
      searchData: {},
      dataList: [],
      noteText: '',
      fileDataIds: [],
      loading: true,
      chooseData: null,
      sourceData: null,
      openDialog: false,
      openDialogDataFile: false,
      tableActionKey: null,
      clickTitleMenuKey: null
    }
  }
}
</script>
